import React from 'react'

export default class ScanInfo extends React.Component {

  onClick() {
    this.props.callback(this.props.color)
  }

  render() {
    return (
    <div className="filter-block-container">
      <div className={`filter-block ${ this.props.color }`} onClick={() => this.onClick()}>
        <div className="inner">
          <div className="score">{this.props.score}</div>
          <div className="score-label">Organisatorische eenheden</div>
        </div>
      </div>
      <div className="info">
        <div className="title"></div>
        <div>{this.props.text}</div>
      </div>
    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Overview/components/ScoreBlock.js